import { useSuspenseQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { fetchCurrentAccount } from "PFCore/services/accounts/account";
import { CurrentAccount, SuspenseQueryOptions } from "PFTypes";

import { accountKeys } from "./query_keys";

export const useCurrentAccount = <TData = CurrentAccount>(
  options: SuspenseQueryOptions<CurrentAccount, unknown, TData> = {}
) =>
  useSuspenseQuery<CurrentAccount, AxiosError, TData>({
    queryKey: accountKeys.basic(),
    queryFn: fetchCurrentAccount,
    retry: false,
    ...options
  });
